<ng-container *ngIf="config.target === '_blank'; else self">
    <a [href]="config.link" [target]="config.target" rel="noopener noreferrer">
        <img [src]="config.image" alt="promotion-banner" width="100%" height="auto" />
    </a>
</ng-container>
<ng-template #self>
    <a [routerLink]="config.link" [target]="config.target" rel="noopener noreferrer">
        <img [src]="config.image" alt="promotion-banner" width="100%" height="auto" />
    </a>
</ng-template>